module.exports = __webpack_public_path__ + "img/Fe.1861d6de.svg";